// Normalizes persisted bundle data because first-session user data can arrive as an array, JSON string, empty value, or stale malformed value.
export const parseUserHandouts = (handouts) => {
    if (Array.isArray(handouts)) {
        return handouts;
    }

    if (handouts == null || typeof handouts !== 'string') {
        return [];
    }

    const trimmedHandouts = handouts.trim();
    if (!trimmedHandouts) {
        return [];
    }

    try {
        const parsedHandouts = JSON.parse(trimmedHandouts);
        return Array.isArray(parsedHandouts) ? parsedHandouts : [];
    } catch (error) {
        console.warn('Unable to parse user handouts, resetting bundle data:', error);
        return [];
    }
};

export const stringifyUserHandouts = (handouts) => JSON.stringify(parseUserHandouts(handouts));
